// extracted by mini-css-extract-plugin
export default {"container":"iDKmxyYR7wxI5rOnQWux","content":"x0sdWeVbg4S28v1S7WUI","contentHeader":"R6JS3fPAO2yFzigekSoP","contentBody":"tvkzIBOyJ74a97_ZsMuY","footer":"XIde9WtaFFMqolCXhJ20"};